const VARIANTS_ENUMS = {
  SUCCESS: "success",
  INFORMATION: "information",
  WARNING: "warning",
  ERROR: "error"
};
export {
  VARIANTS_ENUMS
};
//# sourceMappingURL=constants.mjs.map
